import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, InputAdornment, Stack, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

function SearchField({ value, onChange, onSearch, InputProps = {}, ...props }) {
  const { t } = useTranslation();

  return (
    <TextField
      variant="outlined"
      size="small"
      type="text"
      label={t('general.search')}
      value={value ?? ''}
      onChange={e => onChange(e.target.value)}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Stack spacing={1} direction="row">
              {value && value.length > 0 && (
                <IconButton
                  size="small"
                  onClick={() => {
                    onSearch('');
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              )}
              <IconButton size="small" onClick={() => onSearch(value)}>
                <SearchIcon fontSize="small" />
              </IconButton>
            </Stack>
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
}

SearchField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  InputProps: PropTypes.object,
};

export default SearchField;
